import { createSlice } from '@reduxjs/toolkit';

// Initial state
const initialState: { notificationsData: any[] | null } = {
  notificationsData: null,
};

// Create auth slice
const notificationsSlice = createSlice({
  name: 'notifications',
  initialState,
  reducers: {
    setNotificationsData: (state, action) => {
      state.notificationsData = action.payload;
    },
    addNotification: (state, action) => {
      if (state.notificationsData) {
        state.notificationsData.unshift(action.payload); // Add to top
      }
    },
  },
});

// Export actions
export const { setNotificationsData, addNotification } = notificationsSlice.actions;
export default notificationsSlice.reducer;
